import { Component } from '@angular/core';
import { AEmptyBasePage } from '../empty.base.page';

@Component({
    selector: 'app-empty-settings',
    templateUrl: '../empty.base.page.html',
    styleUrls: ['../empty.base.page.css']
})
export class EmptySettingsPage extends AEmptyBasePage {
    constructor() {
        super();
        this.pageTitleKey = '@@SettingsPageTitle';
        this.pageDescriptionKey = '@@SettingsPageDescription';
        this.settingItems = [
            {
                icon: 'pi pi-cog',
                titleKey: '@@Allgemein',
                descriptionKey: '@@AllgemeinDesc',
                link: '/settings/settings/general'
            },
            {
                icon: 'pi pi-forward',
                titleKey: '@@SystemPassThrough',
                descriptionKey: '@@SystemPassThroughDesc',
                link: '/settings/settings/systempassthrough'
            },
            {
                icon: 'pi pi-envelope',
                titleKey: '@@Email',
                descriptionKey: '@@EmailDesc',
                link: '/settings/settings/email'
            },
            {
                icon: 'pi pi-globe',
                titleKey: '@@Sprachen',
                descriptionKey: '@@SprachenDesc',
                link: '/settings/settings/languages'
            },
            {
                icon: 'pi pi-language',
                titleKey: '@@Ubersetzungen',
                descriptionKey: '@@UbersetzungenDesc',
                link: '/settings/settings/translations'
            },
            {
                icon: 'pi pi-clock',
                titleKey: '@@DynamischerZeitpunkt',
                descriptionKey: '@@DynamischerZeitpunktDesc',
                link: '/settings/settings/dynamictimepoint'
            }
        ];
    }
}
